import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, index, onBookConsultation }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      className="relative bg-card rounded-xl overflow-hidden border border-border group"
    >
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={service?.image}
          alt={service?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent opacity-90" />
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: isHovered ? 1 : 0 }}
          transition={{ duration: 0.3 }}
          className="absolute top-4 right-4 w-12 h-12 rounded-full bg-primary flex items-center justify-center"
        >
          <Icon name={service?.icon} size={24} color="white" />
        </motion.div>
      </div>
      <div className="p-4 md:p-6 lg:p-8">
        <div className="flex items-center gap-3 mb-3 md:mb-4">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name={service?.icon} size={20} color="var(--color-primary)" />
          </div>
          <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">
            {service?.title}
          </h3>
        </div>

        <p className="text-sm md:text-base text-muted-foreground mb-4 md:mb-6 line-clamp-3">
          {service?.description}
        </p>

        <div className="space-y-3 md:space-y-4 mb-4 md:mb-6">
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <Icon name="Clock" size={16} color="var(--color-accent)" />
            <span className="text-muted-foreground">
              Delivery: <span className="text-foreground font-medium">{service?.deliveryTime}</span>
            </span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <Icon name="DollarSign" size={16} color="var(--color-success)" />
            <span className="text-muted-foreground">
              Starting from: <span className="text-foreground font-medium">{service?.startingPrice}</span>
            </span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <Icon name="Users" size={16} color="var(--color-secondary)" />
            <span className="text-muted-foreground">
              <span className="text-foreground font-medium">{service?.clientsServed}</span> clients served
            </span>
          </div>
        </div>

        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: isHovered ? 'auto' : 0, opacity: isHovered ? 1 : 0 }}
          transition={{ duration: 0.3 }}
          className="overflow-hidden mb-4 md:mb-6"
        >
          <div className="space-y-2 pt-4 border-t border-border">
            <p className="text-xs md:text-sm font-medium text-foreground mb-2">Key Features:</p>
            {service?.features?.map((feature, idx) => (
              <div key={idx} className="flex items-start gap-2">
                <Icon name="CheckCircle2" size={14} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                <span className="text-xs md:text-sm text-muted-foreground">{feature}</span>
              </div>
            ))}
          </div>
        </motion.div>

        <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
          <Button
            variant="default"
            fullWidth
            iconName="Calendar"
            iconPosition="left"
            onClick={() => onBookConsultation(service)}
            className="text-sm md:text-base"
          >
            Book Consultation
          </Button>
          <Button
            variant="outline"
            fullWidth
            iconName="ArrowRight"
            iconPosition="right"
            className="text-sm md:text-base"
          >
            View Details
          </Button>
        </div>
      </div>
    </motion.div>
  );
};

export default ServiceCard;